<template>
  <div>
    <h1 class="text-right"><b-badge variant="primary"> {{ roleName }} </b-badge></h1>

    <!-- Dashboard & Roles -->
    <b-card-actions title="Dashboard & Roles" action-collapse>
      <!-- table -->
      <vue-good-table
        max-height="600px"
        styleClass="vgt-table striped"
        :fixed-header="true"
        :columns="columns"
        :rows="dashboard"
        :sort-options="{
          enabled: false,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: name -->
          <div v-if="props.column.field === 'name'">
            <span class="text-nowrap">{{ props.row.name }}</span>
          </div>

          <!-- Column: all -->
          <div v-else-if="props.column.field === 'all'">
            <b-form-checkbox
              :checked="
                roleHasPermissionsIncludes(
                  mapPermissionsIds(props.row?.permissions?.data)
                )
              "
              name="check-button"
              switch
              inline
              @change="
                (isChecked) =>
                  onChangeSwitch(
                    isChecked,
                    mapPermissionsIds(props.row?.permissions?.data),
                    true
                  )
              "
            >
            </b-form-checkbox>
          </div>

          <!-- Column: access -->
          <div v-else-if="props.column.field === 'access'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'access'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: create -->
          <div v-else-if="props.column.field === 'create'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'create'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: show -->
          <div v-else-if="props.column.field === 'show'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'show'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: edit -->
          <div v-else-if="props.column.field === 'edit'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'edit'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: delete -->
          <div v-else-if="props.column.field === 'delete'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'delete'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: other -->
          <div v-else-if="props.column.field === 'others'">
            <template v-if="props.row?.permissions">
              <div v-for="(item, index) in props.row?.permissions?.data" :key="index">
                <b-row v-if="index % 2 === 0">
                  <b-col cols="6">
                    <template v-if="item.group === 'others'">
                      <b-form-checkbox
                        :key="item.id"
                        :checked="roleHasPermissions.includes(item.id)"
                        name="check-button"
                        switch
                        inline
                        @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                      >
                        {{ item.name | strSnakeToPascal }}
                      </b-form-checkbox>
                    </template>
                  </b-col>
                  <b-col v-if="props.row?.permissions?.data[index + 1]" cols="6">
                    <template v-if="props.row?.permissions?.data[index + 1].group === 'others'">
                      <b-form-checkbox
                        :key="props.row.permissions.data[index + 1].id"
                        :checked="roleHasPermissions.includes(props.row.permissions.data[index + 1].id)"
                        name="check-button"
                        switch
                        inline
                        @change="(isChecked) => onChangeSwitch(isChecked, props.row.permissions.data[index + 1].id)"
                      >
                        {{ props.row.permissions.data[index + 1].name | strSnakeToPascal }}
                      </b-form-checkbox>
                    </template>
                  </b-col>
                </b-row>
              </div>
            </template>
          </div>

        </template>
      </vue-good-table>
    </b-card-actions>

    <b-card-actions title="Users" action-collapse>
      <!-- table -->
      <vue-good-table
        max-height="600px"
        styleClass="vgt-table striped"
        :fixed-header="true"
        :columns="columns"
        :rows="user"
        :sort-options="{
          enabled: false,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: name -->
          <div v-if="props.column.field === 'name'">
            <span class="text-nowrap">{{ props.row.name }}</span>
          </div>

          <!-- Column: all -->
          <div v-else-if="props.column.field === 'all'">
            <b-form-checkbox
              :checked="
                roleHasPermissionsIncludes(
                  mapPermissionsIds(props.row?.permissions?.data)
                )
              "
              name="check-button"
              switch
              inline
              @change="
                (isChecked) =>
                  onChangeSwitch(
                    isChecked,
                    mapPermissionsIds(props.row?.permissions?.data),
                    true
                  )
              "
            >
            </b-form-checkbox>
          </div>

          <!-- Column: access -->
          <div v-else-if="props.column.field === 'access'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'access'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: create -->
          <div v-else-if="props.column.field === 'create'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'create'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: show -->
          <div v-else-if="props.column.field === 'show'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'show'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: edit -->
          <div v-else-if="props.column.field === 'edit'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'edit'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: delete -->
          <div v-else-if="props.column.field === 'delete'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'delete'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: other -->
          <div v-else-if="props.column.field === 'others'">
            <template v-if="props.row?.permissions">
              <div v-for="(item, index) in props.row?.permissions?.data" :key="index">
                <b-row v-if="index % 2 === 0">
                  <b-col cols="6">
                    <template v-if="item.group === 'others'">
                      <b-form-checkbox
                        :key="item.id"
                        :checked="roleHasPermissions.includes(item.id)"
                        name="check-button"
                        switch
                        inline
                        @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                      >
                        {{ item.name | strSnakeToPascal }}
                      </b-form-checkbox>
                    </template>
                  </b-col>
                  <b-col v-if="props.row?.permissions?.data[index + 1]" cols="6">
                    <template v-if="props.row?.permissions?.data[index + 1].group === 'others'">
                      <b-form-checkbox
                        :key="props.row.permissions.data[index + 1].id"
                        :checked="roleHasPermissions.includes(props.row.permissions.data[index + 1].id)"
                        name="check-button"
                        switch
                        inline
                        @change="(isChecked) => onChangeSwitch(isChecked, props.row.permissions.data[index + 1].id)"
                      >
                        {{ props.row.permissions.data[index + 1].name | strSnakeToPascal }}
                      </b-form-checkbox>
                    </template>
                  </b-col>
                </b-row>
              </div>
            </template>
          </div>

        </template>
      </vue-good-table>
    </b-card-actions>

    <b-card-actions title="Coupon" action-collapse>
      <!-- table -->
      <vue-good-table
        max-height="600px"
        styleClass="vgt-table striped"
        :fixed-header="true"
        :columns="columns"
        :rows="coupon"
        :sort-options="{
          enabled: false,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: name -->
          <div v-if="props.column.field === 'name'">
            <span class="text-nowrap">{{ props.row.name }}</span>
          </div>

          <!-- Column: all -->
          <div v-else-if="props.column.field === 'all'">
            <b-form-checkbox
              :checked="
                roleHasPermissionsIncludes(
                  mapPermissionsIds(props.row?.permissions?.data)
                )
              "
              name="check-button"
              switch
              inline
              @change="
                (isChecked) =>
                  onChangeSwitch(
                    isChecked,
                    mapPermissionsIds(props.row?.permissions?.data),
                    true
                  )
              "
            >
            </b-form-checkbox>
          </div>

          <!-- Column: access -->
          <div v-else-if="props.column.field === 'access'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'access'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: create -->
          <div v-else-if="props.column.field === 'create'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'create'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: show -->
          <div v-else-if="props.column.field === 'show'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'show'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: edit -->
          <div v-else-if="props.column.field === 'edit'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'edit'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: delete -->
          <div v-else-if="props.column.field === 'delete'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'delete'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: other -->
          <div v-else-if="props.column.field === 'others'">
            <template v-if="props.row?.permissions">
              <div v-for="(item, index) in props.row?.permissions?.data" :key="index">
                <b-row v-if="index % 2 === 0">
                  <b-col cols="6">
                    <template v-if="item.group === 'others'">
                      <b-form-checkbox
                        :key="item.id"
                        :checked="roleHasPermissions.includes(item.id)"
                        name="check-button"
                        switch
                        inline
                        @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                      >
                        {{ item.name | strSnakeToPascal }}
                      </b-form-checkbox>
                    </template>
                  </b-col>
                  <b-col v-if="props.row?.permissions?.data[index + 1]" cols="6">
                    <template v-if="props.row?.permissions?.data[index + 1].group === 'others'">
                      <b-form-checkbox
                        :key="props.row.permissions.data[index + 1].id"
                        :checked="roleHasPermissions.includes(props.row.permissions.data[index + 1].id)"
                        name="check-button"
                        switch
                        inline
                        @change="(isChecked) => onChangeSwitch(isChecked, props.row.permissions.data[index + 1].id)"
                      >
                        {{ props.row.permissions.data[index + 1].name | strSnakeToPascal }}
                      </b-form-checkbox>
                    </template>
                  </b-col>
                </b-row>
              </div>
            </template>
          </div>

        </template>
      </vue-good-table>
    </b-card-actions>

    <b-card-actions title="Company" action-collapse>
      <!-- table -->
      <vue-good-table
        max-height="600px"
        styleClass="vgt-table striped"
        :fixed-header="true"
        :columns="columns"
        :rows="company"
        :sort-options="{
          enabled: false,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: name -->
          <div v-if="props.column.field === 'name'">
            <span class="text-nowrap">{{ props.row.name }}</span>
          </div>

          <!-- Column: all -->
          <div v-else-if="props.column.field === 'all'">
            <b-form-checkbox
              :checked="
                roleHasPermissionsIncludes(
                  mapPermissionsIds(props.row?.permissions?.data)
                )
              "
              name="check-button"
              switch
              inline
              @change="
                (isChecked) =>
                  onChangeSwitch(
                    isChecked,
                    mapPermissionsIds(props.row?.permissions?.data),
                    true
                  )
              "
            >
            </b-form-checkbox>
          </div>

          <!-- Column: access -->
          <div v-else-if="props.column.field === 'access'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'access'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: create -->
          <div v-else-if="props.column.field === 'create'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'create'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: show -->
          <div v-else-if="props.column.field === 'show'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'show'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: edit -->
          <div v-else-if="props.column.field === 'edit'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'edit'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: delete -->
          <div v-else-if="props.column.field === 'delete'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'delete'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: other -->
          <div v-else-if="props.column.field === 'others'">
            <template v-if="props.row?.permissions">
              <div v-for="(item, index) in props.row?.permissions?.data" :key="index">
                <b-row v-if="index % 2 === 0">
                  <b-col cols="6">
                    <template v-if="item.group === 'others'">
                      <b-form-checkbox
                        :key="item.id"
                        :checked="roleHasPermissions.includes(item.id)"
                        name="check-button"
                        switch
                        inline
                        @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                      >
                        {{ item.name | strSnakeToPascal }}
                      </b-form-checkbox>
                    </template>
                  </b-col>
                  <b-col v-if="props.row?.permissions?.data[index + 1]" cols="6">
                    <template v-if="props.row?.permissions?.data[index + 1].group === 'others'">
                      <b-form-checkbox
                        :key="props.row.permissions.data[index + 1].id"
                        :checked="roleHasPermissions.includes(props.row.permissions.data[index + 1].id)"
                        name="check-button"
                        switch
                        inline
                        @change="(isChecked) => onChangeSwitch(isChecked, props.row.permissions.data[index + 1].id)"
                      >
                        {{ props.row.permissions.data[index + 1].name | strSnakeToPascal }}
                      </b-form-checkbox>
                    </template>
                  </b-col>
                </b-row>
              </div>
            </template>
          </div>

        </template>
      </vue-good-table>
    </b-card-actions>

    <b-card-actions title="Mail Template" action-collapse>
      <!-- table -->
      <vue-good-table
        max-height="600px"
        styleClass="vgt-table striped"
        :fixed-header="true"
        :columns="columns"
        :rows="mailTemplate"
        :sort-options="{
          enabled: false,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: name -->
          <div v-if="props.column.field === 'name'">
            <span class="text-nowrap">{{ props.row.name }}</span>
          </div>

          <!-- Column: all -->
          <div v-else-if="props.column.field === 'all'">
            <b-form-checkbox
              :checked="
                roleHasPermissionsIncludes(
                  mapPermissionsIds(props.row?.permissions?.data)
                )
              "
              name="check-button"
              switch
              inline
              @change="
                (isChecked) =>
                  onChangeSwitch(
                    isChecked,
                    mapPermissionsIds(props.row?.permissions?.data),
                    true
                  )
              "
            >
            </b-form-checkbox>
          </div>

          <!-- Column: access -->
          <div v-else-if="props.column.field === 'access'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'access'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: create -->
          <div v-else-if="props.column.field === 'create'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'create'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: show -->
          <div v-else-if="props.column.field === 'show'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'show'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: edit -->
          <div v-else-if="props.column.field === 'edit'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'edit'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: delete -->
          <div v-else-if="props.column.field === 'delete'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'delete'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: other -->
          <div v-else-if="props.column.field === 'others'">
            <template v-if="props.row?.permissions">
              <div v-for="(item, index) in props.row?.permissions?.data" :key="index">
                <b-row v-if="index % 2 === 0">
                  <b-col cols="6">
                    <template v-if="item.group === 'others'">
                      <b-form-checkbox
                        :key="item.id"
                        :checked="roleHasPermissions.includes(item.id)"
                        name="check-button"
                        switch
                        inline
                        @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                      >
                        {{ item.name | strSnakeToPascal }}
                      </b-form-checkbox>
                    </template>
                  </b-col>
                  <b-col v-if="props.row?.permissions?.data[index + 1]" cols="6">
                    <template v-if="props.row?.permissions?.data[index + 1].group === 'others'">
                      <b-form-checkbox
                        :key="props.row.permissions.data[index + 1].id"
                        :checked="roleHasPermissions.includes(props.row.permissions.data[index + 1].id)"
                        name="check-button"
                        switch
                        inline
                        @change="(isChecked) => onChangeSwitch(isChecked, props.row.permissions.data[index + 1].id)"
                      >
                        {{ props.row.permissions.data[index + 1].name | strSnakeToPascal }}
                      </b-form-checkbox>
                    </template>
                  </b-col>
                </b-row>
              </div>
            </template>
          </div>

        </template>
      </vue-good-table>
    </b-card-actions>

    <b-card-actions title="Company Request" action-collapse>
      <!-- table -->
      <vue-good-table
        max-height="600px"
        styleClass="vgt-table striped"
        :fixed-header="true"
        :columns="columns"
        :rows="companyRequest"
        :sort-options="{
          enabled: false,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: name -->
          <div v-if="props.column.field === 'name'">
            <span class="text-nowrap">{{ props.row.name }}</span>
          </div>

          <!-- Column: all -->
          <div v-else-if="props.column.field === 'all'">
            <b-form-checkbox
              :checked="
                roleHasPermissionsIncludes(
                  mapPermissionsIds(props.row?.permissions?.data)
                )
              "
              name="check-button"
              switch
              inline
              @change="
                (isChecked) =>
                  onChangeSwitch(
                    isChecked,
                    mapPermissionsIds(props.row?.permissions?.data),
                    true
                  )
              "
            >
            </b-form-checkbox>
          </div>

          <!-- Column: access -->
          <div v-else-if="props.column.field === 'access'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'access'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: create -->
          <div v-else-if="props.column.field === 'create'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'create'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: show -->
          <div v-else-if="props.column.field === 'show'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'show'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: edit -->
          <div v-else-if="props.column.field === 'edit'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'edit'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: delete -->
          <div v-else-if="props.column.field === 'delete'">
            <template v-if="props.row?.permissions">
              <template v-for="item in props.row?.permissions?.data">
                <template v-if="item?.group == 'delete'">
                  <b-form-checkbox
                    :key="item?.id"
                    :checked="roleHasPermissions.includes(item?.id)"
                    name="check-button"
                    switch
                    inline
                    @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                  >
                    <!-- {{ item?.name | strSnakeToPascal }} -->
                  </b-form-checkbox>
                </template>
              </template>
            </template>
          </div>

          <!-- Column: other -->
          <div v-else-if="props.column.field === 'others'">
            <template v-if="props.row?.permissions">
              <div v-for="(item, index) in props.row?.permissions?.data" :key="index">
                <b-row v-if="index % 2 === 0">
                  <b-col cols="6">
                    <template v-if="item.group === 'others'">
                      <b-form-checkbox
                        :key="item.id"
                        :checked="roleHasPermissions.includes(item.id)"
                        name="check-button"
                        switch
                        inline
                        @change="(isChecked) => onChangeSwitch(isChecked, item.id)"
                      >
                        {{ item.name | strSnakeToPascal }}
                      </b-form-checkbox>
                    </template>
                  </b-col>
                  <b-col v-if="props.row?.permissions?.data[index + 1]" cols="6">
                    <template v-if="props.row?.permissions?.data[index + 1].group === 'others'">
                      <b-form-checkbox
                        :key="props.row.permissions.data[index + 1].id"
                        :checked="roleHasPermissions.includes(props.row.permissions.data[index + 1].id)"
                        name="check-button"
                        switch
                        inline
                        @change="(isChecked) => onChangeSwitch(isChecked, props.row.permissions.data[index + 1].id)"
                      >
                        {{ props.row.permissions.data[index + 1].name | strSnakeToPascal }}
                      </b-form-checkbox>
                    </template>
                  </b-col>
                </b-row>
              </div>
            </template>
          </div>

        </template>
      </vue-good-table>
    </b-card-actions>

  </div>
</template>

<script>
import { BCard, BBadge, BForm, BFormCheckbox, BRow, BCol } from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import strSnakeToPascal from "@/filter/strSnakeToPascal";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {mapGetters} from "vuex";
import { co } from "@fullcalendar/core/internal-common";

export default {
  name: "RolePermissionView",
  components: {
    BForm,
    BCard,
    VueGoodTable,
    BBadge,
    BFormCheckbox,
    BCardActions,
    BRow,
    BCol,
  },

  computed: {
    ...mapGetters({
      authUser: "superAdminAuthModule/getUser",
    }),
  },
  data() {
    return {
      companyId: process.env.VUE_APP_VISERX_COMPANY_ID || null,
      dashboard: [],
      user: [],
      coupon: [],
      company: [],
      mailTemplate: [],
      companyRequest: [],

      pageLength: 10,
      columns: [
        {
          label: "Module",
          field: "name",
        },
        {
          label: "All",
          field: "all",
        },
        {
          label: "Access",
          field: "access",
        },
        {
          label: "Create",
          field: "create",
        },
        {
          label: "Show",
          field: "show",
        },
        {
          label: "Edit",
          field: "edit",
        },
        {
          label: "Delete",
          field: "delete",
        },
        {
          label: "Others",
          field: "others",
        },
      ],
      rows: [],
      roleName: "",
      roleHasPermissions: [],
    };
  },

  async created() {
    const resMD = await this.$api.get(
      "api/super-admin/get-modules-permissions?include=permissions"
    );

    let dashboard = [];
    let user = [];
    let coupon = [];
    let company = [];
    let mailTemplate = [];
    let companyRequest = [];


    resMD.data.data.forEach((item) => {
      const cleanName = item.name.replace(/^Super Admin\s+/i, "");
      switch (cleanName) {
        case "Dashboard":
        case "Roles":
          dashboard.push({
            ...item,
            name: cleanName,
          });
          break;
        case "Coupon":
          coupon.push({
            ...item,
            name: cleanName,
          });
          break;
        case "Company":
          company.push({
            ...item,
            name: cleanName,
          });
          break;
        case "Mail Template":
          mailTemplate.push({
            ...item,
            name: cleanName,
          });
          break;
        case "Company Request":
          companyRequest.push({
            ...item,
            name: cleanName,
          });
          break;
        case "User":
          user.push({
            ...item,
            name: cleanName,
          });
          break;
      }
    });
    
    this.dashboard = dashboard;
    this.user = user;
    this.coupon = coupon;
    this.company = company;
    this.mailTemplate = mailTemplate;
    this.companyRequest = companyRequest;

    const id = this.$route.params.id;
    const resRHP = await this.$api.get(`api/super-admin/roles/${id}?include=permissions`);
    this.roleName = resRHP?.data?.data?.name;
    this.roleHasPermissions = resRHP?.data?.data?.permissions?.data.map(
      (item) => item.id
    );
  },

  methods: {
    roleHasPermissionsIncludes(ids) {
      let result = false;

      for (let i = 0; i < ids.length; i++) {
        if (this.roleHasPermissions.includes(ids[i])) {
          result = true;
        } else {
          return (result = false);
        }
      }

      return result;
    },
    mapPermissionsIds(permissions) {
      return permissions.map((item) => item.id);
    },
    async onChangeSwitch(isChecked, permission_ids, isAll = false) {
      const roleId = this.$route.params.id;

      let data = {
        is_all: isAll,
        is_attach: isChecked,
        permission_id: permission_ids,
      };

      if (isAll) {
        data = {
          is_all: isAll,
          is_attach: isChecked,
          permission_ids,
        };
      }

      try {
        const resPermissions = await this.$api.put(
          `api/super-admin/roles/${roleId}/permission-update?include=permissions`,
          data
        );

        this.roleHasPermissions =
          resPermissions?.data?.data?.permissions?.data.map((item) => item.id);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Success",
            icon: "BellIcon",
            variant: "success",
            text: "Successfully Update",
          },
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: error?.response?.data?.message,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

.checkbox-container {
  display: flex;
  flex-wrap: wrap;
}

.checkbox-container > * {
  flex: 1 0 33%; /* This will make each item take up 1/3 of the container's width */
}
</style>
